import React, { useEffect, useContext } from "react";
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import AppContext from '../../AppContext';
import { ICONS } from '../../img/icons'
import Icon from '../../img/Icon'
import '../../css/general.css'

const InstallPrompt = () => {
    const { t } = useTranslation();
    const { isInstallable, installApp } = useContext(AppContext).appInstallation;

    if (!isInstallable) return null;

    return (
        <>
            <Button color="secondary" style={{ "width": "100%" }} onClick={installApp}>
                <Icon icon={ICONS.ADD} style={{marginTop: "-0.25em", marginRight : "0.4em"}} color='white' size='16' />
                <span className="floatButton-text">{t('AddToHomeScreen')}</span>
            </Button>
        </>
    );
}

export default InstallPrompt;